export class ExportedUtils {
	public inToFtAndIn(totalInches: number): { ft: number, in: number } {
		const ft = Math.floor(totalInches / 12);
		const inches = totalInches - ft * 12;

		return {
			ft: ft,
			in: inches
		};
	}
}
